/**
 * @license
 * Copyright UX Stack. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at LICENSE.md
 */

import { onLCP, onFID, onCLS, onINP, onTTFB, onFCP } from 'web-vitals';
import { Logger } from '../../logger';
import { UXStackInterface, UXStackOptions } from '../../sdk';
import { Module } from '../module';
import { TrackingInterface } from '../tracking/tracking';

export class VitalsModule implements Module {
  public name: string;

  private client: UXStackInterface;
  private track: TrackingInterface;
  private queue: Set<any>;

  constructor() {
    this.name = 'vitals';
    this.queue = new Set();
  }

  public load(client: UXStackInterface, options: UXStackOptions): void {
    Logger.info(`load ${this.name} module`);

    this.client = client;
    this.track = client.getModule('track') as TrackingInterface;

    this.register();
  }

  private register(): void {
    this.client.ready(() => {
      onCLS((v) => this.queue.add(v));
      onFID((v) => this.queue.add(v));
      onLCP((v) => this.queue.add(v));
      onINP((v) => this.queue.add(v));
      onTTFB((v) => this.queue.add(v));
      onFCP((v) => this.queue.add(v));
    });

    // Report all available metrics whenever the page is backgrounded or unloaded.
    addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') {
        this.flush();
      }
    });

    // NOTE: Safari does not reliably fire the `visibilitychange` event when the
    // page is being unloaded. If Safari support is needed, you should also flush
    // the queue in the `pagehide` event.
    addEventListener('pagehide', this.flush);
  }

  private flush(): void {
    if (this.queue.size > 0) {
      // const payload = [...this.queue];
      const payload = Array.from(this.queue);

      Logger.debug('Vitals:', payload);

      this.track.vitals(payload);

      this.queue.clear();
    }
  }
}
